<!--
 * @Description: 关联名片弹窗组件
 * @Author: mdb
 * @Date: 2023-04-19 09:43:13
 * @LastEditTime: 2023-04-19 15:50:54
 * @LastEditors: mdb
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :width="600"
    title="关联名片"
    :confirmLoading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :wrapper-col="{ span: 24 }" ref="formRef" :model="dataForm">
      <a-form-item label="活动名称" name="activityName" :rules="[{ required: true }]">
        <CosInput v-model:value="dataForm.activityName" disabled />
      </a-form-item>
      <a-form-item label="销售名片" name="businessCardIdList" :rules="formRules.select">
        <CosSelect
          v-model:value="dataForm.businessCardIdList"
          :options="cardList"
          mode="multiple"
          show-search
          :filter-option="filterOption"
          allowClear
        />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { queryComboBoxList, showRelBusinessCard, activityBusinessCard } from '@/api/marketing/marketingManage'
import type { BusinessCardListItem } from '@/typings/api/marketingManage'

const formRef = ref()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const dataForm = reactive<{ activityQrcodeId: string; activityName: string; businessCardIdList: string[] }>({
  activityName: '',
  activityQrcodeId: '',
  businessCardIdList: []
})
const formRules = reactive({
  select: [{ required: false, message: '请选择' }]
})
const emit = defineEmits(['fetch'])

const rowsProps = ref<BusinessCardListItem>()
const cardList = ref<BusinessCardListItem[]>([])
const getCardList = () => {
  queryComboBoxList().then((res) => {
    cardList.value = res.data.map((item: any) => ({
      label: `${item.followerName}(${item.follower})`,
      value: item.id
    }))
  })
}
const getRelCardList = (activityQrcodeId: string) => {
  showRelBusinessCard({ activityQrcodeId }).then((res) => {
    dataForm.businessCardIdList = res.data.map((item: any) => item.id) || []
  })
}
const init = (rows?: BusinessCardListItem) => {
  getCardList()
  if (rows?.id) getRelCardList(rows.id)
  rowsProps.value = rows
  if (rows) {
    dataForm.activityQrcodeId = rows.id
    dataForm.activityName = rows.activityName
  }
  visible.value = true
}

const filterOption = (input: string, option: { label: string; value: string }) => {
  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

const handleOk = async () => {
  try {
    await formRef.value?.validate()
    loading.value = true
    const params = {
      activityQrcodeId: dataForm.activityQrcodeId,
      businessCardIdList: dataForm.businessCardIdList
    }
    await activityBusinessCard(params)
    DcMessage.success('操作成功！')
    emit('fetch')
    handleCancel()
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}
const handleCancel = () => {
  formRef.value?.resetFields()
  setTimeout(() => (visible.value = false), 20)
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'CardLinkModal' }
</script>

<style scoped></style>
